/**
 * chromeStore — a tiny CHROME-ONLY view store, kept deliberately SEPARATE from the engine
 * `builderStore` (which must not be touched). It holds presentational shell state that is not part of
 * the saved document and never goes through history/autosave:
 *
 *   - `sidebarTab`     — which panel the left sidebar shows (Sections / Theme settings), driven by the
 *                        topbar icon-rail (chrome feature 1).
 *   - `sidebarCollapsed` — clicking the active icon-rail button collapses the sidebar.
 *   - `askChangesOpen`  — la bulle « Demander un changement » est ouverte. Elle vit ICI et non dans
 *                         la section, parce que DEUX endroits l'ouvrent : la barre d'outils de la
 *                         section, et l'étiquette du bloc sélectionné (27/08 — « quand c'est comme
 *                         ça je vois pas ask for changes, elle doit toujours être près du composant
 *                         sélectionné »). Deux états locaux auraient donné deux bulles ouvertes.
 *
 * Pure UI state, no document mutation, no undo entry.
 */
import { create } from 'zustand';

export type SidebarTab = 'sections' | 'theme';

interface ChromeState {
  sidebarTab: SidebarTab;
  sidebarCollapsed: boolean;
  askChangesOpen: boolean;
  setAskChangesOpen: (open: boolean) => void;
  /** Switch to a tab (and ensure the sidebar is open). Clicking the ACTIVE tab toggles collapse. */
  selectSidebarTab: (tab: SidebarTab) => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useChromeStore = create<ChromeState>((set, get) => ({
  sidebarTab: 'sections',
  sidebarCollapsed: false,
  askChangesOpen: false,
  setAskChangesOpen(open) {
    set({ askChangesOpen: open });
  },
  selectSidebarTab(tab) {
    const { sidebarTab, sidebarCollapsed } = get();
    if (tab === sidebarTab) {
      // Clicking the already-active tab collapses / re-opens the sidebar (Shopify parity).
      set({ sidebarCollapsed: !sidebarCollapsed });
      return;
    }
    set({ sidebarTab: tab, sidebarCollapsed: false });
  },
  setSidebarCollapsed(sidebarCollapsed) {
    set({ sidebarCollapsed });
  },
}));
